<lib-gestion-cabinets-comptables [configuration]="configuration"></lib-gestion-cabinets-comptables>
